import axios from "axios";

let getProjectsController: AbortController | null = null;
let getStageSectionsController: AbortController | null = null;

// On prod we will init export const MEDIA_BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/media`
// On prod we will use process.env.REACT_APP_BACKEND_URL instead of hardcoded  URL in api's calls
export const MEDIA_BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/media`


export async function getProjects() {
    // Abort previous call
    getProjectsController?.abort();
    const controller = new AbortController();
    getProjectsController = controller;

    try {
        const res = await axios.post(
            `${process.env.REACT_APP_BACKEND_URL}/get_projects`,
            {},
            { signal: controller.signal }
        );
        return res.data;
    } finally {
        // Clear controller if it's the latest
        if (getProjectsController === controller) {
            getProjectsController = null;
        }
    }
}

export async function getProject(projectId: any) {
    const res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/get_project`, {
        project_id: projectId,
    });
    console.log("get prohect data:", res.data);
    return res.data;
}

export async function getProjectStages(projectId: any) {
    const res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/get_project_stages`, {
        project_id: projectId,
    });
    return res.data;
}

export async function getStageSections(projectId: any, stageId: any) {
    getStageSectionsController?.abort();
    const controller = new AbortController();
    getStageSectionsController = controller;

    try {
        const res = await axios.post(
            `${process.env.REACT_APP_BACKEND_URL}/get_stage_sections`,
            { project_id: projectId, stage_number: stageId },
            { signal: controller.signal }
        );
        return res.data;
    } finally {
        if (getStageSectionsController === controller) {
            getStageSectionsController = null;
        }
    }
}

export async function getSectionSubsections(projectId: any, stageId: any, sectionId: any) {
    const res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/get_section_subsections`, {
        project_id: projectId, stage_number: stageId, section_number: sectionId
    });
    return res.data;
}

export async function getSectionSubsectionsList(projectId: any, stageId: any) {
    const res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/get_subsections_list`, {
        project_id: projectId, stage_number: stageId
    });
    return res.data;
}

export async function getStagesByName(stageName: string) {
    const res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/search`, {
        query: stageName
    });
    console.log("Inside the function: ", res.data);
    return res.data;
}

export async function getProjectUploads(projectId: any, serialNumber: any) {
    const res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/get_project_uploads_data`, {
        project_id: projectId,
        serial: serialNumber
    });
    return res.data;
}

export async function getProjectQuarter(projectId: any) {
    const res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/changes_from_previous_quarter`, {
        project_id: projectId
    });
    console.log("data:", res.data);
    return res.data;
}

export async function getProjectQuarterChangesFromLastQuarter(projectId: any) {
    const res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/changes_from_previous_quarter`, {
        project_id: projectId
    });
    console.log("data:", res.data);
    return res.data;
}

export async function getProjectQuarterHistory(projectId: any, serial:any) {
    const res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/get_history`, {
        project_id: projectId,
        serial: serial
    });
    console.log("data:", res.data);
    return res.data;
}